/** @jsxImportSource @emotion/react */

import React from "react";
import { css } from "@emotion/react";
import { Box } from "reflexbox";
import { CustomizerContext } from "./CustomizerContext";
import { ControlGroup } from "./ControlGroup";

export function Controls({}) {
	let {
		customizerAttributes,
		presets,
		ChangeState,
		refreshPreview,
		AttributesState,
		updateAttributes,
		SelectedPresetsState,
	} = React.useContext(CustomizerContext);
	let { pcoplusKey, churchCenterUrl } = customizerAttributes;

	let [attributes, setAttributes] = AttributesState;

	let [selectedPreset, setSelectedPreset] = SelectedPresetsState;

	let [changed, checkIfChanged] = ChangeState;

	// let functionalityPresets = presets.filter((p) => p.type === "Functionality");
	// let stylePresets = presets.filter((p) => p.type === "Style");

	// let presetsRender = (
	// 	<>
	// 		<PresetGroup
	// 			presets={functionalityPresets}
	// 			SelectedPresetsState={SelectedPresetsState}
	// 		/>
	// 		<PresetGroup
	// 			name=""
	// 			presets={stylePresets}
	// 			SelectedPresetsState={SelectedPresetsState}
	// 		/>
	// 	</>
	// );

	return (
		<Box>
			<Box
				mb={0}
				css={css`
					& label {
						font-size: 0.9em;
					}
				`}
			>
				<div className="accordion" id="controls">
					{["Functionality", "Style", "Language"].map((groupName, index) => {
						return (
							<ControlGroup
								name={groupName}
								key={groupName}
								defaultOpen={index === 0}
							/>
						);
					})}
				</div>

				<Box textAlign="center" mt={4}>
					<button
						// disabled={changed === false}
						type="button"
						className="btn btn-primary"
						onClick={() => {
							refreshPreview();
						}}
					>
						<i className="fas fa-sync-alt"></i>
						&nbsp; Update Preview
					</button>
				</Box>
			</Box>
		</Box>
	);
}
